import { Backdrop, Box, Button, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSubscriptionStore } from '../data';
import { Colors } from '../utils/Colors';

export const withoutOverlay = ['valid', 'beta', 'scheduled', 'dismissed'];

export const OverlayWithButton = () => {
  const { status, setStatus } = useSubscriptionStore();
  const dismiss = () => setStatus('dismissed');
  return (
    <Backdrop
      sx={{ overflow: 'hidden' }}
      open={!withoutOverlay.includes(status)}
    >
      <Box
        sx={{
          alignItems: 'center',
          border: `1px solid ${Colors.richBlack}`,
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            backgroundColor: Colors.celeste,
            display: 'flex',
            justifyContent: 'space-between',
            padding: '1.5rem',
            width: '100%'
          }}
        >
          <Typography variant="h5">Warning</Typography>
          {status === 'expiring' ? (
            <IconButton onClick={dismiss}>
              <Close />
            </IconButton>
          ) : null}
        </Box>
        <Box
          sx={{
            backgroundColor: Colors.ocdWhite,
            padding: '1.5rem',
            width: '100%'
          }}
        >
          <Typography variant="h6">
            {status === 'expiring'
              ? 'Your subscription is expiring soon'
              : 'A subscription is required in order to use OCDfeat'}
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: Colors.ocdWhite,
            padding: '1.5rem',
            width: '100%'
          }}
        >
          {status === 'expiring' ? (
            <Button
              color="inherit"
              variant="outlined"
              sx={{
                backgroundColor: Colors.ocdWhite,
                color: Colors.richBlack,
                borderRadius: '20px',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                marginRight: '1.5rem'
              }}
              onClick={dismiss}
            >
              <Typography variant="h6">Dismiss</Typography>
            </Button>
          ) : null}
          <Link to="/checkout">
            <Button
              color="inherit"
              sx={{
                backgroundColor: Colors.ocdGreen,
                borderRadius: '20px',
                color: Colors.richBlack,
                fontWeight: 800,
                paddingLeft: '1rem',
                paddingRight: '1rem'
              }}
            >
              <Typography variant="h6">
                {status === 'expiring'
                  ? 'Update Payment Method'
                  : 'Gain access to OCDfeat'}
              </Typography>
            </Button>
          </Link>
        </Box>
      </Box>
    </Backdrop>
  );
};
